import { render, staticRenderFns } from "./ChartMostSoldProducts.vue?vue&type=template&id=5086bd57"
import script from "./ChartMostSoldProducts.vue?vue&type=script&lang=js"
export * from "./ChartMostSoldProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports